import { VegaDialog } from "@vega-core/components/Modals/VegaDialog/VegaDialog";
import { m } from "@vega-core/paraglide/messages";

import { CredentialRow } from "./CredentialRow";

// Hardcoded for this iteration by decision (PRD §9): no environment-aware
// configuration; the docs credentials are read-only and meant to be passed to
// clients together with the docs link (through separate channels from keys).
export const API_DOCS_URL =
  "https://api.vega-test.link/vegaapi/docs/scalar#tag/externalreporting";
export const API_DOCS_USERNAME = "vega";
export const API_DOCS_PASSWORD = "vega-api-docs-readonly";

export const ApiDocsModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => (
  <VegaDialog
    open={open}
    setOpen={setOpen}
    title={m.settings_reportingApiKeys_docsModal_title()}
  >
    <div className="text-left">
      <p className="body-base-regular text-text/secondary mb-4">
        {m.settings_reportingApiKeys_docsModal_description()}
      </p>
      <div className="divide-y divide-border/primary">
        <CredentialRow
          label={m.settings_reportingApiKeys_docsModal_url()}
          value={API_DOCS_URL}
        />
        <CredentialRow
          label={m.settings_reportingApiKeys_docsModal_username()}
          value={API_DOCS_USERNAME}
        />
        <CredentialRow
          label={m.settings_reportingApiKeys_docsModal_password()}
          value={API_DOCS_PASSWORD}
        />
      </div>
    </div>
  </VegaDialog>
);
